export const downloadFile = (fileName: string, url: string) => {
  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.setAttribute('target', '_blank');

  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const base64ToDownloadableUrl = (fileContent: string, fileType: string) => {
  const binaryString = atob(fileContent);

  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const size = bytes.byteLength;

  const blob = new Blob([bytes], { type: fileType });

  const url = URL.createObjectURL(blob);

  return {
    url,
    size,
  };
};
